import { render, staticRenderFns } from "./FormatCurrentPagePropertyEditTool.vue?vue&type=template&id=56eda33a&scoped=true&"
import script from "./FormatCurrentPagePropertyEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatCurrentPagePropertyEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatCurrentPagePropertyEditTool.vue?vue&type=style&index=0&id=56eda33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eda33a",
  null
  
)

export default component.exports